import { styled } from '@mui/material/styles'

export const Heading = styled('div', {
  name: 'Heading',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro';
  font-size: 16px;
`
